import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { AntibioticsIdentifiedFarmer, POTypeEnum, SupplierTypeEnum } from "@gtpl/shared-models/common-models";
import { Farm } from "./farms.entity";
import { ApiProperty } from "@nestjs/swagger";
import { SupplierLog } from "./suppliers-log-entity";

// import { VendorsPriceList } from "../vendors-price-list/entities/vendor-price-list.entity";

@Entity('suppliers')
export class Supplier {

    @PrimaryGeneratedColumn("increment", { name: 'supplier_id' })
    supplierId: number;

    @Column("char", {
        nullable: false,
        length: 50,
        name: "code"
    })
    @Index({ unique: false })
    supplierCode: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "name"
    })
    supplierName: string;

    @Column({
        type: 'enum',
        enum: SupplierTypeEnum,
        nullable: false,
        name: 'supplier_category',
        default: SupplierTypeEnum.DEALER
    })
    supplierCategory: SupplierTypeEnum;


    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "gst_number"
    })
    gstNumber: string;

    @Column("int", {
        nullable: true,
        name: "broker_id",
        default:0
    })
    brokerId: number;



    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "contact_person"
    })
    contactPerson: string;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "street"
    })
    street: string;
    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "apartment"
    })
    apartment: string;
    @Column("varchar", {
        nullable: true,
        length: 70,
        name: "city"
    })
    city: string;

    @Column("varchar", {
        nullable: true,
        length: 100,
        name: "state"
    })
    state: string;

    @Column("varchar", {
        nullable: true,
        length: 70,
        name: "district"
    })
    district: string;
    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "postal_code"
    })
    postalCode: string;

    @Column("int", {
        nullable: true,
        name: "commission"
    })
    commission: number;


    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "bank_acc_no"
    })
    bankAccNo: string;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "bank_ifsc"
    })
    bankIfsc: string;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "bank_name"
    })
    bankName: string;
    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "bank_branch"
    })
    bankBranch: string;
    @Column("int", {
        nullable: true,
        name: "payment_period"
    })
    paymentPeriod: number;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "contact_number"
    })
    contactNumber: string;

    @Column("varchar", {
        nullable: false,
        length: 50,
        name: "aadhar_number"
    })
    aadharNumber: string;

    @Column({
        type:'enum',
        enum: AntibioticsIdentifiedFarmer, 
        name: 'a_b_identified_farmer',
        nullable:false,
        default:AntibioticsIdentifiedFarmer.APPROVED,
    })
    antibioticsIdentifiedFarmer: AntibioticsIdentifiedFarmer; 

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "email_id"
    })
    emailId: string;
    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean;
    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user"
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
        @Column("varchar", {
        nullable: true,
        length: 20,
        name: "pan_number"
    })
    panNumber: string;

    @ApiProperty({ type: Farm })
    @OneToMany(type => Farm, farm => farm.supplierInfo, { cascade: true })
    farmInfo: Farm[];

    @ApiProperty({ type: SupplierLog })
    @OneToMany(type => SupplierLog, e => e.supplierInfo, { cascade: true })
    supplierLogInfo: SupplierLog;
}
